/*
 *
 * HubspotVerify constants
 *
 */

import { defineApiActionTypes } from 'utils/action-helper';
const prefix = 'ui/containers/HubspotVerify';

/*
 * @dev defineApiActionTypes a function that
 * return concat base with START,SUCCESS,FAILURE
 */
export const VERIFY_HUBSPOT = defineApiActionTypes(`${prefix}/VERIFY_HUBSPOT_START`);
